import { SearchResultListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultListItem";
import { getSortValueTechnician } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-menu.utils";
import { TechnicianRow, SearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { routes } from "@/routes";
import { generatePath } from "@/routes/routes.utils";

type Props = {
    data: TechnicianRow;
    onClick: (item: SearchResultItem) => void;
    isRecentSearch?: boolean;
    className?: string;
};

export const TechnicianListItem = (props: Props) => {
    const { data } = props;

    const item: SearchResultItem = {
        type: "technician",
        data,
        sortValue: getSortValueTechnician(data),
    };

    return (
        <SearchResultListItem
            label={data.Name ?? "Unknown technician"}
            chip={data.TechnicianCode}
            title={"Technician"}
            // @ts-expect-error FIXME: link can be undefined
            url={generatePath(routes.technicianDetail, {
                params: { technicianCode: data.TechnicianCode },
            })}
            icon={"lely-icon-person"}
            onClick={() => props.onClick(item)}
            isRecentSearch={props.isRecentSearch}
            className={props.className}
        />
    );
};
